
const DETAILS_GEOMETRY_TYPE_FLAGS = {
	Point: 'isPoint',
	MultiPoint: 'isPoint',
	LineString: 'isLineString',
	MultiLineString: 'isLineString',
	Polygon: 'isPolygon',
	MultiPolygon: 'isPolygon'
};

export default class GeoJsonUtil {

	static _getDetailsRecursive (geoJson, details) {

		if (!geoJson || !geoJson.type) return;

		switch (geoJson.type) {

		case 'FeatureCollection':
			
			if (!geoJson.features || !geoJson.features.length) return;
			
			for (let feature of geoJson.features) {

				this._getDetailsRecursive(feature, details);
			}

			return;

		case 'Feature':

			this._getDetailsRecursive(geoJson.geometry, details);
			return;

		case 'Point':
		case 'LineString':
		case 'Polygon':

			this._setDetailsGemetryType(details, geoJson.type);
			details.totalGeometries++;

			if (!details.firstGeometry) details.firstGeometry = geoJson;

			return;

		case 'MultiPoint':
		case 'MultiLineString':
		case 'MultiPolygon':
			
			this._setDetailsGemetryType(details, geoJson.type);
			details.totalGeometries += geoJson.coordinates.length;

			if (!details.firstGeometry) details.firstGeometry = geoJson;

			return;
		}
	}

	static _setDetailsGemetryType (details, type) {
		
		if (details.geometryTypes.indexOf(type) === -1) {

			var flag = DETAILS_GEOMETRY_TYPE_FLAGS[type];
			details[flag] = true;
			details.geometryTypes.push(type);
		}
	}

	/**
	 * Método que extrai alguns detalhes sobre o geoJson, como o número
	 * de geometrias e quais os tipos de geometria contidos nele.
	 */
	static getDetails (geoJson) {

		let details = {
			isPolygon: false,
			isPoint: false,
			isLineString: false,
			geometryTypes: [],
			totalGeometries: 0,
			firstGeometry: null
		};
		
		if (!geoJson || !geoJson.type) return details;

		this._getDetailsRecursive(geoJson, details);

		return details;
	}

	static getFirstGeometry (geojson) {

		let details = this.getDetails(geojson);

		return details.firstGeometry;
	}
};



// WEBPACK FOOTER //
// ./src/utils/geoJsonUtil.js